// extracted by mini-css-extract-plugin
export var container = "_sk-0";
export var table = "_sk-2";
export var tableWrapper = "_sk-1";